module.exports = __webpack_public_path__ + "img/back_hover.1b5979ac.png";